module.exports = "https://static.wmbcdn.com/uniweb/images/5e803198bcc5de14b0f66a96206d892d.svg";